// extracted by mini-css-extract-plugin
module.exports = {"main-container":"main-container_1L2G","show-header":"show-header_1nwO","not-show-header":"not-show-header_1_ce"};